import React from 'react';
import GGCLObligationDefault from './GGCLObligationSwitch/GGCLObligationDefault';

function GGCLObligationSwitch(props) {
  const { obligationID, type } = props;

  switch (type) {
    case 'ClientFavouritesSmall':
      return '';
    default:
      return <GGCLObligationDefault obligationID={obligationID} />;
  }
}

export default React.memo(GGCLObligationSwitch);
